// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2025project/q1/2025reporter/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const save = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};

const getDetail = (unionid: any) => {
  return http.get(`${urlPrefix}user-detail`, {
    params: {
      unionid,
    },
  });
};


export { getBaseInfo, save, getDetail };
